import { SET_IS_ELECTRIC } from '../actions/types';

export default function isElectric(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_IS_ELECTRIC:
				if (action.payload) {
					const { detail } = action.payload?.spec || '';
					// VEHICLE IS CONSIDERED ELECTRIC IF BATTERY TYPE IS ONE OF FOLLOWING:
					// - "Battery Electric Vehicle" (BEV)
					// - "Plugin Hybrid Electric Vehicle" (PHEV)
					// - "Extended Range Electric Vehicle" (EREV)
					const electricTypes = ['PHEV', 'BEV', 'EREV'];
					return electricTypes.some((type) => detail.includes(type));
				}
				return false;

			// no default
		}
	}

	return state;
}
